import React, { useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";
import { useSelector } from "react-redux";
import { endPoints } from "../../config/end-points";
// import { cuteToast } from "../UI/cute";





const Rewritediv = ( props ) => {

  
  const {sendRequest: rewriteText} = useHttp();
  const [ai_response, setAi_response] = useState({});
  const [showAiTexts, setShowAiTexts] = useState(false);

  const [ pageloader, setPageloader ] = useState(false);

const editSlideData = useSelector((state) => state.campaign.editSlideData);
const [promt, setPromt] = useState("");

const { setShowRewritediv } = props;

const hidediv = () => {
  setShowRewritediv(false);
}

  useEffect(() => {
    if(editSlideData){

        const dataArray = Object.entries(editSlideData);
        let quotes = '';

        dataArray.map(([key, value]) => {
            
          if(key && key.includes("engageleads")){
            quotes += value+' ';
          }
          return null;
        });

        setPromt(quotes);
        // console.log(quotes);

    }
  }, [editSlideData ]);
  
  const promthandle = (data) => {

    // console.log(data.target.value);
    setPromt(data.target.value);
  }

  const getQuotes = async () => {
    
    setPageloader(true);
    let promt1 = "Please Rewrite the following content and character count should not exceed existing content's chracter length i.e, "+promt.length+":  " + promt ;
    rewriteText(
      {
        url: endPoints.genQuote,
        method: "POST",
        body: {
          promt: promt1 ,
          max_tokens: 200
        }
      },
      async (response) => {
        
        setShowAiTexts(true);
        setPageloader(false);
        setResult(response);
      }
    );
  };

  const setResult = (data)=>{

    if( data.status !== 200){
      console.log(data.message);
      // cuteToast({
      //   type: "error",
      //   message: data.message,
      //   timer: 5000
      // });

    }else{
      console.log(data.data);
      setAi_response(data.data)
    }
  }


  return (
    <>
      <div className="row position-relative">
          <div className="col-md-12 px-3 text-align-left">
            <div className="mb-3">
              <button type="button" className="position-absolute ai_div-cross" onClick={hidediv} >X</button>
              <label className="form-label"><b>Content</b></label>
              <textarea type="text" placeholder="Enter Json Data" className="form-control AiPromptDiv" value={promt} onChange={(e) => promthandle(e)} >
              </textarea>
              <span className="">Character Count: {promt.length}</span>
            </div>
          </div>

        <div className="d-flex flex-right px-3 pt-2">
          <div className="input-group justify-content-end ">
            
            <button
              className="btn btn-outline-secondary shadow-none p-2"
              type="button"
              id="button-addon2"
              onClick={getQuotes}
            >
              Rewrite
            </button>
          </div>
        </div>
        
      </div>

      <div className="row mt-4">
          {showAiTexts && !pageloader && (
            <div className="container">
              <div className="rewrite-content" >
                {ai_response}
              </div>
              <span className="text-muted"> {ai_response.length} / {promt.length}</span>
              
            </div>
          )}

          {pageloader && (
            <div className="position-relative">
              <div className="loader2">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          )}
      </div>
    </>
  );
};

export default Rewritediv;
